module.exports = __webpack_public_path__ + "media/images/flags/UA-b62775628c85f9960ee9b424c890af50.svg";